import { EliteLandingPageState } from '../types/misc.types'

const UPGRADE_TO_ELITE_BUTTON_TEXT = `Upgrade to Elite @ <span style="font-weight: 700;">
                 ₹{amount}/yr + GST </span>`

export const eliteLandingPageStateConfig: {
  [key in `${EliteLandingPageState}`]: {
    buttonText: string
    supportText?: string
    topText?: string
    isDisabled?: true
  }
} = {
  [EliteLandingPageState.ONB_NOT_INITIATED]: {
    buttonText: UPGRADE_TO_ELITE_BUTTON_TEXT,
    topText: 'Special price for first 10k members'
  },
  [EliteLandingPageState.ONB_IN_PROGRESS]: {
    buttonText: UPGRADE_TO_ELITE_BUTTON_TEXT,
    topText: 'Special price for first 10k members'
  },
  [EliteLandingPageState.PAYMENT_NOT_INITIATED]: {
    buttonText: UPGRADE_TO_ELITE_BUTTON_TEXT,
    topText: 'Special price for first 10k members'
  },
  [EliteLandingPageState.PAYMENT_PENDING]: {
    buttonText: UPGRADE_TO_ELITE_BUTTON_TEXT,
    isDisabled: true,
    supportText:
      'Awaiting payment confirmation from your bank. If payment fails, the money will be refunded within 3 working days.'
  },
  [EliteLandingPageState.RE_INITIATE_PAYMENT]: {
    buttonText: 'Retry Payment',
    supportText:
      'Your last payment has failed. Any money deducted will be refunded within 3 working days. You can retry payment to complete your purchase.'
  },
  [EliteLandingPageState.REFUND_PENDING]: {
    buttonText: UPGRADE_TO_ELITE_BUTTON_TEXT,
    supportText: 'Your membership has been cancelled. Refund will be credited in 5-7 working days.',
    topText: 'Special price for first 10k members'
  },
  [EliteLandingPageState.PAYMENT_COMPLETED_SUBSCRIPTION_PENDING]: {
    buttonText: 'Complete eSign',
    supportText: 'Your payment was successful. Complete eSign to activate your Elite membership.'
  },
  [EliteLandingPageState.PAYMENT_COMPLETED_SUBSCRIPTION_PENDING_WARNING]: {
    buttonText: 'Complete eSign',
    supportText:
      'Your payment was successful. Complete eSign before {activationExpiryDate} to activate your Elite membership.'
  },
  [EliteLandingPageState.REFUND_DUE_TO_ESIGN_PENDING]: {
    buttonText: UPGRADE_TO_ELITE_BUTTON_TEXT,
    supportText:
      'Your Elite membership could not be activated as the eSign was not completed in time. The refund has been initiated and will be credited to source in 3-5 days.',
    topText: 'Special price for limited time only'
  },
  [EliteLandingPageState.FAMILY_ONBOARDING_NOT_ALLOWED]: {
    buttonText: 'Upgrade to Elite',
    topText: 'You need to be an Elite member to make this purchase for {familyMemberName}'
  },
  [EliteLandingPageState.ELITE]: {
    isDisabled: true,
    buttonText: 'Something went wrong'
  },
  [EliteLandingPageState.PAYMENT_FAILED]: {
    buttonText: 'Retry Payment',
    supportText:
      'Your last payment has failed. Any money deducted will be refunded within 3 working days. You can retry payment to complete your purchase.'
  },
  [EliteLandingPageState.PLAN_EXPIRED]: {
    buttonText: 'Renew Elite'
  },
  [EliteLandingPageState.ELITE_PAYMENT_COMPLETED_PRIME_PENDING]: {
    buttonText: 'Elite payment pending',
    isDisabled: true
  }
}
